import React from "react";
import "./style.scss";
const InputRow = ({ children }) => {
  if (!children) {
    return null;
  }
  return <div className="input-row">{children}</div>;
};
export default InputRow;
